import { sharedReducer, SharedState } from './Shared/reducer';
import { combineReducers, Reducer } from "redux";
import { connectRouter } from 'connected-react-router';
import { history } from "./middleware";
import { notificationReducer, NotificationState } from './Notifications/reducer';
import { libraryReducer, LibraryState } from './Library/reducer';
import { performanceReportReducer, PerformanceReportState } from './PerformanceReport/reducer';
import { adminReducer, AdminState } from './Admin/reducer';
import { dealerReducer, DealerState } from './Dealers/reducer';


export interface AppState {
  shared: SharedState;
  notifications: NotificationState,
  library: LibraryState,
  performanceReport: PerformanceReportState,
  admin: AdminState,
  dealers: DealerState,
  router: any;
}

export const rootReducer: Reducer<AppState> = combineReducers<AppState>({
  shared: sharedReducer, 
  notifications: notificationReducer,
  library: libraryReducer,
  performanceReport: performanceReportReducer,
  admin: adminReducer,
  dealers: dealerReducer,
  router: connectRouter(history),
 });